import { render, staticRenderFns } from "./ModalProductFilter.vue?vue&type=template&id=1a442a25&"
import script from "./ModalProductFilter.vue?vue&type=script&lang=js&"
export * from "./ModalProductFilter.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports